'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPi = function TiPi(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.2 14.2c-0.7-0.6-1.7-0.6-2.4 0-2.1 2.1-5.5 2.1-7.6 0-3.4-3.4-9-3.4-12.4 0-0.6 0.7-0.6 1.7 0 2.4s1.7 0.6 2.4 0c0.6-0.6 1.3-1.1 2.1-1.3v13c0 1 0.8 1.7 1.7 1.7s1.7-0.7 1.7-1.7v-13c0.8 0.2 1.5 0.7 2.1 1.3 1.3 1.3 2.9 2.1 4.5 2.4v9.3c0 1 0.8 1.7 1.7 1.7s1.7-0.7 1.7-1.7v-9.3c1.6-0.3 3.2-1.1 4.5-2.4 0.6-0.7 0.6-1.7 0-2.4z' })
        )
    );
};

exports.default = TiPi;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/pi.js
// module id = 2142
// module chunks = 0